import { useAppSelector, selectUserOrganisation } from '@app.raytd.com/store'
import { FeatureKey, isFeatureLocked } from '@/app/config/features'
import { FeatureGate } from '@/components/raytd/FeatureGate'

interface RestrictedRouteProps {
  feature: FeatureKey
  children: React.ReactElement
}

/**
 * RestrictedRoute component that protects routes from direct URL access.
 * If the feature is locked, it shows the FeatureGate page instead of redirecting.
 * This preserves the URL context and provides educational friction.
 * 
 * @example
 * ```tsx
 * <Route path="/reports/advanced" element={
 *   <RestrictedRoute feature="advanced_reports">
 *     <AdvancedReportsPage />
 *   </RestrictedRoute>
 * } />
 * ```
 */
export function RestrictedRoute({
  feature,
  children,
}: RestrictedRouteProps) {
  const organisation = useAppSelector(selectUserOrganisation)
  const locked = isFeatureLocked(feature, organisation)

  if (locked) {
    return <FeatureGate feature={feature} />
  }

  return children
}

